<div class="container-fluid">
    <div class="col-12">
      <app-standalone-header></app-standalone-header>
    </div>
  </div>

  <div class="wizard form_wizard overflow-hidden backBtnPadding">
    <button mat-button class="btnBack mr-4 mt-2 mb-2 absolute_back_button float-right"
      [routerLink]="['/current_business']">Back
    </button>
</div>

  <div class="row m-0 h-100 login_container">

    <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 offset-md-4 setPadding mt-4">
      <!-- <div class="row m-0 h-100 login">
  
        <div class="row_tab">
          <div class="mainform"> -->
            <mat-card class="matC">
            <div class="title col-12 align-self-center">
              <h3 class="mb-4">Identity Verification</h3>
            </div>
            <form class="" [formGroup]='search_input'>
              <div class="row m-0">
                <div class="col-12 p-0 email">
                  <mat-form-field class="col-12">
                    <input type="text" matInput placeholder="First Name" formControlName="first_name">
                    <mat-error *ngIf="search_input.get('first_name').errors?.required">Enter First Name</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-12 p-0 email">
                  <mat-form-field class="col-12">
                    <input type="email" matInput placeholder="Last Name" formControlName="last_name">
                    <mat-error *ngIf="search_input.get('last_name').errors?.required">Enter Last Name</mat-error>
                  </mat-form-field>
                </div>
                <div class="col-12 p-0 email">
                  <mat-form-field class="col-12">
                    <input type="email" matInput placeholder="Email Address" formControlName="user_email">
                    <mat-error *ngIf="search_input.get('user_email').errors?.required">Enter Email</mat-error>
                  </mat-form-field>
                </div>
              </div>
            </form>
            <div class="text-right col-12 ">
              <!-- <button  mat-raised-button
              color="primaryCus" (click) = "backToLogin()" class="mx-2">Back To Login</button> -->
              <button  mat-raised-button (click) = 'openPopUP()' class="mx-2"
              color="primaryCus">Verify Your Identity</button>
            </div>
            </mat-card>
          </div>
        </div>
        <div class="col-12">
        <app-footer></app-footer>
        </div>
      <!-- </div>
    </div>
    <div class="col-sm-12 col-md-5 col-lg-5 col-xl-5 pos-rel welcomeBgNew h-100">
      <app-sidescreen></app-sidescreen>
  
    </div>
  </div> -->
